<template>
  <div class="flex flex_between">
    <md-field :class="[{ 'md-error': error }]">
      <label >{{ $t("seller.upload.Currency") }}</label>
      <TbSelect v-model="moduleValue"
				@md-selected="onSelect"
				:search-allow="true"
				:options="options"
				options-value-field="isoCode"
				options-display-field="isoCode"
				:disabled="disabled"
				:required="required"
      />
      <span v-if="error" class="validation-error">{{ error }}</span>
    </md-field>
  </div>
</template>
<script>
import {currencyApi} from "@/common/api/currencyApi";

export default {
  props: {
    labelText: {type: String, default: "value"},
    disabled: {type: Boolean, default: false},
    error: { type: Boolean, default: "" },
    required: {type: Boolean, default: false},
    value: {type: String, default: ""},
    includeOnly: {type: Object, default: []}
  },
  data() {
    return {
      moduleValue: "",
      options: [],
      currencyFilter: []
    };
  },
  beforeMount() {
    this.getList();
  },
  mounted() {
    this.moduleValue = this.value;
    this.currencyFilter = this.includeOnly
  },
  methods: {
    onSelect(val) {
      this.$emit("input", val);
    },
    getList() {
      currencyApi
        .ListEnabled()
        .then(() => {
        	//Use only limited currencies for now
          var options = [
            { isoCode: "CHF", translationKey: "currency.chf" },
            { isoCode: "EUR", translationKey: "currency.eur" },
            { isoCode: "GBP", translationKey: "currency.gbp" },
            { isoCode: "USD", translationKey: "currency.usd" }
          ]
          if (this.currencyFilter.length > 0) {
            this.options = options.filter(entry => this.currencyFilter.includes(entry.isoCode))
          } else {
            this.options = options
          }
        })
        .catch(this.toast);
    }
  },
  watch: {
    value() {
      this.moduleValue = this.value;
    }
  }
};
</script>
